import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "privilege__play-desc" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", null, "身份"),
  /*#__PURE__*/_createElementVNode("th", null, "超级会员"),
  /*#__PURE__*/_createElementVNode("th", null, "白金会员"),
  /*#__PURE__*/_createElementVNode("th", null, "非会员")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("td", null, "播放次数", -1)

import PopWrapper from '@remote/components/PopWrapper.vue'
import PlayTimePNG from '@shared/assets/img/play-times.png'
import { usePromisifyDialog } from '@shared/utils/dialog'
import { IconClose } from '@xunlei/thunder-icon-vue'
import { useBaseStore } from '@remote/store/base'
import { computed, onMounted, PropType } from 'vue'
import { store } from '@remote/store'
import { usePlayTimePrivilege } from '@shared/composable/privilege'
import { useEnvStore } from '@remote/store/env'
import { stat } from '@remote/utils/stat'


export default /*#__PURE__*/_defineComponent({
  props: {
  theme: {
    type: String as PropType<'light' | 'dark'>,
    default: 'light',
  },
  scene: {
    type: String as PropType<'nfo' | 'download_list'>,
    default: 'nfo',
  },
},
  emits: ["dialog-close"],
  setup(__props, { emit }: { emit: ({
  (e: 'dialog-close'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props





const statFromMap = {
  nfo: 'cinema',
  download_list: 'completed',
}

const { isShow, close } = usePromisifyDialog(emit)

const baseStore = useBaseStore()

const envStore = useEnvStore()

const user = computed(() => store.state.deviceInfoWatchData?.user)

const config = computed(() => baseStore.baseConfig)

const {
  privilegeTable,
  privilegeDescription,
  buttonInfo,
} = usePlayTimePrivilege(user, config, props.scene, true)

/**
   * 海康 不展示开通会员按钮
   */
const isButtonShow = computed(() => {
  const platform = store.state.deviceInfoWatchData.product_name
  return platform !== 'hiksemi'
})

const onClose = () => {
  const vipInfo = store.state.deviceInfoWatchData?.user?.vip
  stat({
    category: 'remote_control_h5',
    action: 'vip_lgfile_play_privilege_pop_click',
    data: {
      from: statFromMap[props.scene],
      click_id: 'close',
      vip_type: vipInfo?.is_vip ? '3' : '5',
    },
  })
  close(undefined)
}

const goVip = () => {
  const vipInfo = store.state.deviceInfoWatchData?.user?.vip
  stat({
    category: 'remote_control_h5',
    action: 'vip_lgfile_play_privilege_pop_click',
    data: {
      from: statFromMap[props.scene],
      click_id: 'open',
      vip_type: vipInfo?.is_vip ? '3' : '5',
    },
  })
  store.dispatch('goVip', { 
    position: vipInfo?.is_vip ? 'play_fs_ch' : 'play_fs_bj',
  })
  close(undefined)
}

const description = computed(() => {
  if (['jkj', 'ugreen', 'lenovo'].includes(envStore.pathEnv)) {
    return '会员专享<strong>片库播放次数特权</strong>'
  }
  return '会员专享<strong>播放次数特权</strong>'
})

onMounted(() => {
  stat({
    category: 'remote_control_h5',
    action: 'vip_lgfile_play_privilege_pop_show',
    data: {
      from: statFromMap[props.scene],
    },
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PopWrapper, {
    close: onClose,
    "is-show": _unref(isShow)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass({
        'privilege-play-times': true,
        [`is-${__props.theme}`]: true
      }),
        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
      }, [
        _createVNode(_unref(IconClose), {
          width: "24",
          height: "24",
          onClick: onClose
        }),
        _createElementVNode("img", { src: _unref(PlayTimePNG) }, null, 8, _hoisted_1),
        _createElementVNode("h1", { innerHTML: _unref(description) }, null, 8, _hoisted_2),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(privilegeDescription)), 1),
        _createElementVNode("table", null, [
          _hoisted_4,
          _createElementVNode("tbody", null, [
            _hoisted_5,
            _createElementVNode("td", null, _toDisplayString(_unref(privilegeTable).svip), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(privilegeTable).vip), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(privilegeTable).normal), 1)
          ])
        ]),
        (_unref(isButtonShow))
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "button-base vip",
              onClick: goVip
            }, _toDisplayString(_unref(buttonInfo).button), 1))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _: 1
  }, 8, ["is-show"]))
}
}

})